import RegisterWizard from "../Componant/Authentication/RegisterWizard";
import ForgetPassword from "../Pages/Authentication/ForgetPassword";
import LoginSimple from "../Pages/Authentication/LoginSimple";
import LoginWithBgImage from "../Pages/Authentication/LoginWithBgImage";
import LoginWithImageTwo from "../Pages/Authentication/LoginWithImageTwo";
import LoginWithSweetalert from "../Pages/Authentication/LoginWithSweetalert";
import LoginWithTooltip from "../Pages/Authentication/LoginWithTooltip";
import LoginWithValidation from "../Pages/Authentication/LoginWithValidation";
import Maintenance from "../Pages/Authentication/Maintenance";
import RegisterSimple from "../Pages/Authentication/RegisterSimple";
import RegistrationWithBgImage from "../Pages/Authentication/RegistrationWithBgImage";
import RegistrationWithImageTwo from "../Pages/Authentication/RegistrationWithImageTwo";
import ResetPassword from "../Pages/Authentication/ResetPassword";
import UnlockUser from "../Pages/Authentication/UnlockUser";
import ComingSimple from "../Pages/ComingSoon/ComingSimple";
import ComingWithImageBg from "../Pages/ComingSoon/ComingWithImageBg";
import ComingWithVideoBg from "../Pages/ComingSoon/ComingWithVideoBg";
import Error400 from "../Pages/ErrorPages/Error400";
import Error401 from "../Pages/ErrorPages/Error401";
import Error403 from "../Pages/ErrorPages/Error403";
import Error404 from "../Pages/ErrorPages/Error404";
import Error500 from "../Pages/ErrorPages/Error500";
import Error503 from "../Pages/ErrorPages/Error503";

export const AUTH_ROUTES = [
  //Error Pages
  { path: `${process.env.PUBLIC_URL}/others/error-400`, element: <Error400 /> },
  { path: `${process.env.PUBLIC_URL}/others/error-401`, element: <Error401 /> },
  { path: `${process.env.PUBLIC_URL}/others/error-403`, element: <Error403 /> },
  { path: `${process.env.PUBLIC_URL}/others/error-404`, element: <Error404 /> },
  { path: `${process.env.PUBLIC_URL}/others/error-500`, element: <Error500 /> },
  { path: `${process.env.PUBLIC_URL}/others/error-503`, element: <Error503 /> },

  //Coming soon
    { path: `${process.env.PUBLIC_URL}/coming-soon/coming-soon`, element: <ComingSimple /> },
    { path: `${process.env.PUBLIC_URL}/coming-soon/coming-soon-bg-video`, element: <ComingWithVideoBg /> },
    { path: `${process.env.PUBLIC_URL}/coming-soon/coming-soon-bg-img`, element: <ComingWithImageBg /> },

  // Authentication
    { path: `${process.env.PUBLIC_URL}/auth/login`, element: <LoginSimple /> },
    { path: `${process.env.PUBLIC_URL}/auth/login-bg-img`, element: <LoginWithBgImage /> },
    { path: `${process.env.PUBLIC_URL}/auth/login-bg-img2`, element: <LoginWithImageTwo /> },
    { path: `${process.env.PUBLIC_URL}/auth/login-bs-validation`, element: <LoginWithValidation /> },
    { path: `${process.env.PUBLIC_URL}/auth/login-bs-tt-validation`, element: <LoginWithTooltip /> },
    { path: `${process.env.PUBLIC_URL}/auth/login-sa-validation`, element: <LoginWithSweetalert /> },
    { path: `${process.env.PUBLIC_URL}/auth/sign-up`, element: <RegisterSimple /> },
    { path: `${process.env.PUBLIC_URL}/auth/sign-up-one`, element: <RegistrationWithBgImage /> },
    { path: `${process.env.PUBLIC_URL}/auth/sign-up-two`, element: <RegistrationWithImageTwo /> },
    { path: `${process.env.PUBLIC_URL}/auth/sign-up-wizard`, element: <RegisterWizard /> },
    { path: `${process.env.PUBLIC_URL}/auth/unlock`, element: <UnlockUser /> },
    { path: `${process.env.PUBLIC_URL}/auth/forget-password`, element: <ForgetPassword /> },
    { path: `${process.env.PUBLIC_URL}/auth/reset-password`, element: <ResetPassword /> },
    { path: `${process.env.PUBLIC_URL}/auth/maintenance`, element: <Maintenance /> },
];
